/**
* DevExpress Analytics (widgets\common\pathRequest.js)
* Version:  21.2.13
* Build date: Apr 10, 2023
* Copyright (c) 2012 - 2023 Developer Express Inc. ALL RIGHTS RESERVED
* License: https://www.devexpress.com/Support/EULAs/universal.xml
*/
"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var PathRequest = (function () {
    function PathRequest(fullPath, pathParts) {
        if (pathParts === void 0) { pathParts = []; }
        this.pathParts = pathParts;
        this.path = '';
        this.fullPath = fullPath;
        if (fullPath) {
            if (fullPath.indexOf('.') !== -1) {
                var pathComponents = fullPath.split('.');
                this.id = this.ref = pathComponents[0];
                pathComponents.splice(0, 1);
                this.path = pathComponents.join('.');
            }
            else {
                this.id = this.ref = fullPath;
            }
        }
    }
    return PathRequest;
}());
exports.PathRequest = PathRequest;
